import { Pipe, PipeTransform } from '@angular/core';
import { ProductCategory } from '@spa/api';
import { Helper } from '../classes';

@Pipe({
  name: 'productCategory'
})
export class ProductCategoryPipe implements PipeTransform {
  transform(status: ProductCategory): string {
    return Helper.textsHelper().getProductCategoryName(status);
  }
}
